






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import DetailsDialog from "../Dialogs/DetailsDialog.vue";
import CreateDialog from "../Dialogs/CreateDialog.vue";
import { bus } from "../../main";
import { router } from "../../_router";
import { EnterpriseNominaResp } from "../../_models/enterpriseNominaResp";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { UserInfo } from "../../_models/userInfo";
import EditDialog from "../../components/Edit/EditDialog.vue";
import ConfirmAssignmentDialog from "../Dialogs/ConfirmAssignmentDialog.vue";
import ActivitiesDocDialog from "../Dialogs/ActivitiesDocDialog.vue";
import ReportVisiteDialog from "../Dialogs/ReportVisiteDialog.vue";
import AttestatoFinaleDialog from "../Dialogs/AttestatoFinaleDialog.vue";
import DownloadRecords from "../DownloadRecords.vue";
import QuestionarioDialog from "../Dialogs/QuestionarioDialog.vue";
import StatusDoc from "../ActivitiesDoc/StatusDoc.vue";
import { activity } from "../../_store/activity.module";
import * as temp from "../../_store/temp.module";
import StoricoAttivitaDialog from "../Dialogs/StoricoAttivitaDialog.vue";
import WorkshopQuestionarioDialog from "../Dialogs/WorkshopQuestionarioDialog.vue";
import GeneraDocDialog from "../Dialogs/GeneraDocDialog.vue";
import CVDialog from "../Dialogs/CVDialog.vue";
import RubricaAziendeDialog from "../Dialogs/RubricaAziendeDialog.vue";
import FoglioFirmeDialog from "../Dialogs/FoglioFirmeDialog.vue";
import NoteAziendeDialog from "@/components/Dialogs/NoteAziendeDialog.vue";
import RateDialog from "../Dialogs/RateDialog.vue";
import { userUtils } from "@/_utils";

@Component({
	components: {
		DetailsDialog,
		CreateDialog,
		EditDialog,
		ConfirmAssignmentDialog,
		ActivitiesDocDialog,
		ReportVisiteDialog,
		AttestatoFinaleDialog,
		DownloadRecords,
		QuestionarioDialog,
		StatusDoc,
		StoricoAttivitaDialog,
		WorkshopQuestionarioDialog,
		GeneraDocDialog,
		CVDialog,
		RubricaAziendeDialog,
		FoglioFirmeDialog,
		NoteAziendeDialog,
		RateDialog
	}
})
export default class ListDataTable extends Vue {
	@Prop() params!: any;
	@Prop() createDialogParams!: object;
	@Prop() createReportDialogParams!: object;
	@Prop() filterParams!: any;
	@Prop() reportParams!: any;
	@Prop() recordType!: string;
	@Prop() loadingVar!: boolean;
	@Prop() listaTurni!: any;
	private loadingData: boolean;
	private anno: string[];
	private autorizzazione: string[];
	private anni: string[];
	private anniScolastici: any[];
	private docResp: string[];
	private articolazioni: any;
	private sezione: any[];
	private tipoAttivita: any[];
    private userInfo: any;

	private tipoAttivitaFilter: any;
	private autorizzazioneFilter: string;
	private annoFilter: string;
	private annoScolasticoFilter: any;
	private docRespFilter: string;
	private articolazioneFilter: string;
	private sezioneFilter: string;
	private aree: any;
	private areeFilter: string;
	private turni: any;
	private turniFilter: string;
	private statusTirocinioFilter: string
	private statusTirocini: any[];

	private search: string;
	private showDocDialog: boolean;
	private showReportDialog: boolean;
	private showStoricoDialog: boolean;
	private showFoglioFirme: boolean;
	private showAttestatoFinaleDialog: boolean;
	private showQuestionarioWorkshop: boolean;
	private showNoteAziendeDialog: boolean;


	// private testItems:any

	// pagination = { sortBy: "turno", descending: true, rowsPerPage: -1 };

	constructor() {
		super();
		this.userInfo = { ruoloUtente: [] };
		this.search = "";
		this.loadingData = true;
		this.anno = ["3", "4", "5"];
		this.autorizzazione = ["Inviati", "Eliminati", "Confermati", "Tutti"];
		this.autorizzazioneFilter = "Tutti";
		this.anni = ["Tutti", "3", "4", "5"];
		this.annoFilter = "Tutti";
		this.annoScolasticoFilter = 0;
		this.anniScolastici = [];
		this.docRespFilter = "Tutti";
		this.docResp = ["Inviati", "Eliminati", "Confermati", "Tutti"];
		this.articolazioni = this.params.listaArticolazioni;
		this.articolazioneFilter = "Tutte";
		this.sezioneFilter = "Nessuna";
		this.sezione = ["Nessuna", "A", "B", "C", "D", "E", "F"];
		this.tipoAttivita = [
			"Tutti",
			"Tirocini Estivi",
			"Tirocini Formativi",
			"Tirocini Re/Inserimento",
			"FSL Estiva",
			"Workshop",
			"Colloqui CV"
		];
		this.tipoAttivitaFilter = "Tutti";
		this.aree = this.params.listaAree;
		this.areeFilter = "Tutte";
		this.turni = this.params.listaTurni;
		this.turniFilter = "Tutti";
		this.statusTirocinioFilter = "Tutti";
		this.statusTirocini = ["Tutti", "Accettati", "Rifiutati", "Terminati", "Confermati", "Annullati"]

		this.showDocDialog = true;
		this.showReportDialog = true;
		this.showStoricoDialog = true;
		this.showFoglioFirme = true;
		this.showAttestatoFinaleDialog = true;
		this.showQuestionarioWorkshop = true;
		this.showNoteAziendeDialog = true;
	}

	@Watch("annoScolasticoFilter")
	onAnnoScolasticoChange(value: string) {
		if (this.params.type !== "colloqui") {
			this.loadingData = true;
		}
		this.changeAnnoScolastico();
		// bus.$emit("autorizzazioneFilter", value)
	}

	@Watch("annoFilter")
	onAutorizzazioneChange(value: string) {
		this.filterChange();
		// bus.$emit("autorizzazioneFilter", value)
	}

	@Watch("autorizzazioneFilter")
	onAnnoChange(value: string) {
		this.filterChange();
		// bus.$emit("autorizzazioneFilter", value)
	}

	@Watch("docRespFilter")
	onDocRespChange(value: string) {
		this.filterChange();
		// bus.$emit("autorizzazioneFilter", value)
	}

	@Watch("articolazioneFilter")
	onArticolazioneChange(value: string) {
		this.filterChange();
		// bus.$emit("autorizzazioneFilter", value)
	}

	@Watch("sezioneFilter")
	onSezioneChange(value: string) {
		this.filterChange();
	}

	@Watch("tipoAttivitaFilter")
	onTipoAttivtaChange(value: string) {
		this.filterChange();
		// bus.$emit("autorizzazioneFilter", value)
	}

	@Watch("areeFilter")
	onAreaChange(value: string) {
		this.filterChange();
		// bus.$emit("autorizzazioneFilter", value)
	}

	@Watch("turniFilter")
	onTurnoChange(value: string) {
		this.filterChange();
		// bus.$emit("autorizzazioneFilter", value)
	}

	@Watch("statusTirocinioFilter")
	onStatusTirociniChange(value: string) {
		this.filterChange();
	}

	concludiAttivita(idRichiesta: number, activityType: string) {
		var payload = {
			idRichiesta: idRichiesta,
			activityType: activityType
		};

		user
			.dispatchConcludiAttivita(this["$store"], payload)
			.then(() => {
				bus.$emit("successfullOperation", "Attività conclusa correttamente");
				bus.$emit("loadAssegnazioni");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	block(item: any) {
		var payload = {
			idAllievo: item.idUtente,
			idIstitutoAnnoScolastico: item.idIstitutoAnnoScolastico,
			idClasse: item.idClasse,
			gestioneAlternanza: !item.gestioneAlternanza
		};
		if (confirm("Bloccare l'allievo dalla FSL Estiva?")) {
			user
				.dispatchChangeStudentActivityStatus(this["$store"], payload)
				.then(() => {
					bus.$emit("successfullOperation", "Utente bloccato con successo");
					item.gestioneAlternanza = false;
				})
				.catch(error => {
					if (error.response.status === 403) {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						this["$router"].push("/login");
					} else {
						bus.$emit(
							"errorOperation",
							"Errore nella modifica delle informazioni"
						);
					}
				});
		}
	}

	enable(item: any) {
		var payload = {
			idAllievo: item.idUtente,
			idIstitutoAnnoScolastico: item.idIstitutoAnnoScolastico,
			idClasse: item.idClasse,
			gestioneAlternanza: !item.gestioneAlternanza
		};
		if (confirm("Sbloccare l'allievo per l'attività di FSL Estiva?")) {
			user
				.dispatchChangeStudentActivityStatus(this["$store"], payload)
				.then(() => {
					bus.$emit("successfullOperation", "Utente sbloccato con successo");
					item.gestioneAlternanza = true;
				})
				.catch(error => {
					if (error.response.status === 403) {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						this["$router"].push("/login");
					} else {
						bus.$emit(
							"errorOperation",
							"Errore nella modifica delle informazioni"
						);
					}
				});
		}
	}

	verifyUser(piva: string) {
		var payload = {
			piva: piva
		};
		if (confirm("Verificare l'utente selezionato?")) {
			user
				.dispatchVerificaUtente(this["$store"], payload)
				.then(() => {
					bus.$emit("successfullOperation", "Utente verificato con successo");
					bus.$emit("loadEnterprisesList");
				})
				.catch(error => {
					if (error.response.status === 403) {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						this["$router"].push("/login");
					} else {
						bus.$emit(
							"errorOperation",
							"Errore nella modifica delle informazioni"
						);
					}
				});
		}
	}

	reviewAutorizzazione(item: any) {
		var userInfo: UserInfo = user.readUserInfo(this["$store"]);
		var ruoloUtente: any = userInfo.ruoloUtente;
		router.push({
			name: "review",
			params: {
				docType: "autorizzazioneStudente",
				idDoc: item.idDocAutorizzazione,
				idStatoDoc: item.idStatoDoc,
				ruoloUtente: ruoloUtente
			}
		});
	}

	reviewNominaResponsabile(item: any) {
		var userInfo: UserInfo = user.readUserInfo(this["$store"]);
		var ruoloUtente: any = userInfo.ruoloUtente;
		router.push({
			name: "review",
			params: {
				docType: "nominaResponsabile",
				idDoc: item.idDocNominaResp,
				idStatoDoc: item.idStatoDoc,
				ruoloUtente: ruoloUtente
			}
		});
	}

	send(item: any) {
		var payload = {
			nomeAllievo: item.nomeUtente,
			cognomeAllievo: item.cognomeUtente,
			emailAllievo: item.emailUtente,
			turno: item.turno,
			nomeAzienda: item.denominazione,
			emailAzienda: item.emailAzienda,
			linkColloquio: item.linkStanza
		};
		user
			.dispatchSendLinkColloquioCV(this["$store"], payload)
			.then(() => {
				bus.$emit("successfullOperation", "Invito inviato con successo");
			})
			.catch(error => {
				bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
			});
	}

	refuseAssignment(idRichiesta: number, activityType: string) {
		var payload = {
			idRichiesta: idRichiesta,
			activityType: activityType
		};
		user
			.dispatchRefuseAssignment(this["$store"], payload)
			.then(() => {
				bus.$emit("successfullOperation", "Abbinamento eliminato con successo");
				bus.$emit("loadPreAssegnazioni");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	confirmAssignment(idRichiesta: number, activityType: string, info: any) {
		var payload = {
			idRichiesta: idRichiesta,
			activityType: activityType,
			numeroProtocollazione: "",
			dataProtocollazione: new Date().toISOString()
		};
		var payload2 = {
			emailAzienda: info.emailAzienda,
			emailTirocinante: info.emailUtente,
			denominazioneAzienda: info.denominazioneAzienda,
			tirocinante: info.allievo,
			activityType: activityType
		};
		user
			.dispatchConfirmAbbinamento(this["$store"], payload)
			.then(() => {
				user
					.dispatchGeneraDocumenti(this["$store"], payload)
					.then(() => {
						bus.$emit(
							"successfullOperation",
							"Abbinamento confermato e documenti generati con successo "
						);
						if (activityType === "tirocinioFormativo") {
							user
								.dispatchSendEmailDocGenerati(this["$store"], payload2)
								.then(() => {
									bus.$emit("loadPreAssegnazioni");
								})
								.catch(error => {
									if (error.response.status === 403) {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
										this["$router"].push("/login");
									} else {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
									}
								});
						} else if (activityType === "tirocinioEstivo") {
							user
								.dispatchSendEmailDocGenerati(this["$store"], payload2)
								.then(() => {
									bus.$emit("loadPreAssegnazioni");
								})
								.catch(error => {
									if (error.response.status === 403) {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
										this["$router"].push("/login");
									} else {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
									}
								});
						} else if (activityType === "alternanza") {
							bus.$emit("loadPreAssegnazioni");
							// nessun invio email
						} else if (activityType === "tirocinioReIns") {
							user
								.dispatchSendEmailDocGenerati(this["$store"], payload2)
								.then(() => {
									bus.$emit("loadPreAssegnazioni");
								})
								.catch(error => {
									if (error.response.status === 403) {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
										this["$router"].push("/login");
									} else {
										bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
									}
								});
						}
					})
					.catch(error => {
						if (error.response.status === 403) {
							bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
							this["$router"].push("/login");
						} else {
							bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						}
					});
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	changeStatusPresenza(
		idColloquio: number,
		colloquioAvvenuto: boolean,
		soggetto: string
	) {
		var payload = {
			idColloquio: idColloquio,
			colloquioAvvenuto: colloquioAvvenuto,
			soggetto: soggetto
		};
		user
			.dispatchChangeStatusPresenzaColloquio(this["$store"], payload)
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	deleteColloquio(colloquio: any) {
		var deleteStr: string =
			"Eliminare il colloquio tra " +
			colloquio.username +
			" e " +
			colloquio.denominazione +
			" delle ore " +
			colloquio.turno +
			"?";
		var payload = {
			idColloquio: colloquio.idColloquio
		};
		if (confirm(deleteStr)) {
			user
				.dispatchDeleteColloquioCV(this["$store"], payload)
				.then(() => {
					bus.$emit("successfullOperation", "Colloquio eliminato con successo");
					bus.$emit("updateColloquiList", colloquio.idColloquio);
				})
				.catch(error => {
					if (error.response.status === 403) {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						this["$router"].push("/login");
					} else {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					}
				});
		}
	}

	changeTurno(idTurno: number, idColloquio: number) {
		var payload = {
			idTurno: idTurno,
			idColloquio: idColloquio
		};
		user
			.dispatchChangeTurnoColloquioCV(this["$store"], payload).then(() => {
				this.filterChange()
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	filterChange() {
		var filters = {
			filtroAutorizzazione: "Tutti",
			filtroAnni: "",
			filtroDocResp: "",
			fitroArticolazione: "",
			filtroSezione: "",
			filtroTipoAttivita: "",
			filtroArea: "",
			filtroTurno: "",
			filtroStatusTirocinio: ""
		};
		if (this.params.filterType === "listaAllievi") {
			filters = {
				filtroAutorizzazione: this.autorizzazioneFilter,
				filtroAnni: this.annoFilter,
				filtroDocResp: "",
				fitroArticolazione: this.articolazioneFilter,
				filtroSezione: this.sezioneFilter,
				filtroTipoAttivita: "",
				filtroArea: "",
				filtroTurno: "",
				filtroStatusTirocinio: ""
			};
			bus.$emit("filtroAllievi", filters);
		} else if (this.params.filterType === "listaAziende") {
			filters = {
				filtroAutorizzazione: "",
				filtroAnni: "",
				filtroDocResp: this.docRespFilter,
				fitroArticolazione: "",
				filtroSezione: "",
				filtroTipoAttivita: "",
				filtroArea: "",
				filtroTurno: "",
				filtroStatusTirocinio: ""
			};
			bus.$emit("filtroAziende", filters);
		} else if (this.params.filterType === "listaColloqui") {
			filters = {
				filtroAutorizzazione: "",
				filtroAnni: "",
				filtroDocResp: "",
				fitroArticolazione: this.articolazioneFilter,
				filtroSezione: "",
				filtroTipoAttivita: "",
				filtroArea: this.areeFilter,
				filtroTurno: this.turniFilter,
				filtroStatusTirocinio: ""
			};
			bus.$emit("filtroColloquiCV", filters);
		} else if (this.params.filterType === "workshop") {
			filters = {
				filtroAutorizzazione: "",
				filtroAnni: "",
				filtroDocResp: "",
				fitroArticolazione: this.articolazioneFilter,
				filtroSezione: "",
				filtroTipoAttivita: "",
				filtroArea: "",
				filtroTurno: "",
				filtroStatusTirocinio: ""
			};
			bus.$emit("filtroIscrizioniWorkshop", filters);
		} else if (this.params.filterType === "listaReport") {
			filters = {
				filtroAutorizzazione: "",
				filtroAnni: "",
				filtroDocResp: "",
				fitroArticolazione: this.articolazioneFilter,
				filtroSezione: "",
				filtroTipoAttivita: this.tipoAttivitaFilter,
				filtroArea: "",
				filtroTurno: "",
				filtroStatusTirocinio: ""
			};
			bus.$emit("filtroReport", filters);
		} else if (this.params.filterType === "questionariWorkshopAllievi") {
			filters = {
				filtroAutorizzazione: this.autorizzazioneFilter,
				filtroAnni: this.annoFilter,
				filtroDocResp: "",
				fitroArticolazione: this.articolazioneFilter,
				filtroSezione: this.sezioneFilter,
				filtroTipoAttivita: "",
				filtroArea: "",
				filtroTurno: "",
				filtroStatusTirocinio: ""
			};
			bus.$emit("filtroQuestionariWorkshopAllievi", filters);
		} else if (this.params.filterType === "listaAbbinamenti") {
			filters = {
				filtroAutorizzazione: "",
				filtroAnni: "",
				filtroDocResp: "",
				fitroArticolazione: "",
				filtroSezione: "",
				filtroTipoAttivita: "",
				filtroArea: "",
				filtroTurno: "",
				filtroStatusTirocinio: this.statusTirocinioFilter
			}
			bus.$emit("filtroAbbinamenti", filters);
		}
	}

	changeAnnoScolastico() {
		if (this.params.type !== "workshop") {
			bus.$emit("changeAnnoScolastico", this.annoScolasticoFilter);
		} else {
			if (this.params.filterType === "questionariWorkshopAllievi") {
				bus.$emit(
					"changeAnnoScolasticoWorkshopAllievi",
					this.annoScolasticoFilter
				);
			} else if (this.params.filterType === "questionariWorkshopAziende") {
				bus.$emit(
					"changeAnnoScolasticoWorkshopAziende",
					this.annoScolasticoFilter
				);
			}
		}
	}

	loadAnniScolastici() {
		data
			.dispatchAnniScolastici(this["$store"])
			.then(result => {
				result.forEach((element: any) => {
					this.anniScolastici.push({
						//@ts-ignore
						nomeAnno: element.nomeAnnoScolastico,
						//@ts-ignore
						idAnno: element.idAnnoScolastico
					});
				});
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	changeStatusPresenzaWorkshop(
		idInformazioneWorkshop: number,
		presenzaWorkshop: boolean
	) {
		if (presenzaWorkshop === false) {
			presenzaWorkshop = true;
		} else {
			presenzaWorkshop = false;
		}
		var payload = {
			idInformazioneWorkshop: idInformazioneWorkshop,
			presenzaWorkshop: presenzaWorkshop
		};
		user
			.dispatchChangeStatusPresenzaWorkshop(this["$store"], payload)
			.then(() => {
				//this.loadCandidature();
				bus.$emit("loadSchedulazioneWorkshop");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	changeAppredistatoCheck(idRichiesta: number) {

	}

	confirmDeleteAbbinamento(item: any) {
		if (window.confirm('Sei sicuro di voler eliminare questo abbinamento?')) {
			this.deleteAbbinamento(item);
		}
	}

	deleteAbbinamento(item: any) {
		user.dispatchDeleteAbbinamentoAlternanza(this["$store"], item.idInfoAlternanza)
			.then(() => {
				bus.$emit("successfullOperation", "Abbinamento eliminato con successo");
				bus.$emit("loadPreAssegnazioni");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	deleteApprendistato(item: any) {
		user.dispatchDeleteApprendistato(this["$store"], item.idApprendistato)
			.then(() => {
				bus.$emit("successfullOperation", "Apprendistato eliminato con successo");
				bus.$emit("loadApprendistati");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	created() {
		var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
		var token = localStorage.getItem("userToken");
		var parsedToken: any;
		if (token !== null) {
			parsedToken = userUtils.parseToken(token);
		}
		var payload = {
			idUtente: parsedToken.IdUtente,
			tipoSoggetto: parsedToken.IdTipoSoggetto,
			username: parsedToken.Username
		};
		const existingUserInfo = user.readUserInfo(this["$store"]);
		if (existingUserInfo) {
			this.userInfo = existingUserInfo;
		}
		user
		.dispatchSetUserInfo(this["$store"], payload)
		.then(() => {
			this.userInfo = user.readUserInfo(this["$store"]); 
		})

		if (this.loadingVar === false) {
			this.loadingData = false;
		}
		if (this.params.type === "colloqui") {
			this.loadingData = false;
		}
		this.loadAnniScolastici();
		this.annoScolasticoFilter = idAnnoScolastico;

		bus.$on("dataLoaded", () => {
			this.loadingData = false;
		});

		bus.$on("destroyDocDialog", async () => {
			this.showDocDialog = false;
			await this.$nextTick();
			this.showDocDialog = true;
		});

		bus.$on("destroyReportDialog", async () => {
			this.showReportDialog = false;
			await this.$nextTick();
			this.showReportDialog = true;
		});

		bus.$on("destroyStoricoDialog", async () => {
			this.showStoricoDialog = false;
			await this.$nextTick();
			this.showStoricoDialog = true;
		});

		bus.$on("destroyFoglioFirmeDialog", async () => {
			this.showFoglioFirme = false;
			await this.$nextTick();
			this.showFoglioFirme = true;
		});

		bus.$on("destroyAttestatoFinaleDialog", async () => {
			this.showAttestatoFinaleDialog = false;
			await this.$nextTick();
			this.showAttestatoFinaleDialog = true;
		});

		bus.$on("destroyQuestionarioWorkshopDialog", async () => {
			this.showQuestionarioWorkshop = false;
			await this.$nextTick();
			this.showQuestionarioWorkshop = true;
		});

		bus.$on("destroyNoteAziendeDialog", async () => {
			this.showNoteAziendeDialog = false;
			await this.$nextTick();
			this.showNoteAziendeDialog = true;
		});

		bus.$on("createdColloquio", async () => {
			var filters = {
				filtroAutorizzazione: "",
				filtroAnni: "",
				filtroDocResp: "",
				fitroArticolazione: this.articolazioneFilter,
				filtroSezione: "",
				filtroTipoAttivita: "",
				filtroArea: this.areeFilter,
				filtroTurno: this.turniFilter
			};
			bus.$emit("loadColloquiList", filters)
		})
	}
}
